import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";
import { Content } from "antd/es/layout/layout";
import Header from "../components/header";
import { Layout } from "antd";

const RouteCRM = () => {
  const { user } = useAuth();

  useEffect(() => {
    let type = "";
    if (user) {
      type = user.type;
    }

    if (!type) {
      window.location.assign("/login");
    }
  }, []);

  let type = "";
  if (user) {
    type = user.type;
  }

  return type ? (
    <Layout>
      <Header sidebar={false} />
      <Layout>
        <Content className="content" style={{ padding: "50px 0" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  ) : (
    <></>
  );
};

export default RouteCRM;
